export const arePathsEqual = (path1, path2) => {
  const firstPart1 = path1.split("/").filter((part) => part !== "")[0];
  const firstPart2 = path2.split("/").filter((part) => part !== "")[0];

  return firstPart1 === firstPart2;
};
